// extracted by mini-css-extract-plugin
export var contactform = "SectionContactForm-module--contactform--0d2a8";
export var formcontainer = "SectionContactForm-module--formcontainer--69d09";
export var innerwrapper = "SectionContactForm-module--innerwrapper--65456";
export var input = "SectionContactForm-module--input--50539";
export var inputtextarea = "SectionContactForm-module--inputtextarea--0c43f";
export var introtext = "SectionContactForm-module--introtext--3f8f3";
export var select = "SectionContactForm-module--select--7cc82";
export var textinputlabel = "SectionContactForm-module--textinputlabel--a705f";
export var title = "SectionContactForm-module--title--b20fd headings-module--sectionHeading--a8f67";
export var titlewrapper = "SectionContactForm-module--titlewrapper--d1a3e";